import { useLiveQuery } from "dexie-react-hooks";
import { ExpenseKind, formatUsd, newId } from "@haulsheet/core";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { TextInput } from "../components/ui/Field";
import { getDb } from "../db/dexie";
import { useAuthStore } from "../store/authStore";
import { useUnsavedGuard } from "../pwa/unsaved";
import { getSyncClient } from "../sync/SyncClient";
import { localDateIso } from "../logs/fuel";

export function LogsMaintenanceScreen() {
  const me = useAuthStore((s) => s.me);
  const [dollars, setDollars] = useState("");
  const [note, setNote] = useState("");
  useUnsavedGuard("logs-maintenance", dollars.trim() !== "" || note.trim() !== "");
  const rows = useLiveQuery(async () => {
    return getDb()
      .expense.filter(
        (e) => e.kind === ExpenseKind.maintenance && e.deletedAt == null,
      )
      .reverse()
      .sortBy("occurredOn");
  }, []);

  async function add() {
    if (!me) return;
    const amount = Math.round(Number(dollars) * 100);
    if (!Number.isFinite(amount) || amount <= 0) return;
    const id = newId();
    const now = new Date().toISOString();
    await getSyncClient().mutate({
      entity: "expense",
      op: "upsert",
      id,
      baseVersion: null,
      row: {
        id,
        orgId: me.org.id,
        version: 0,
        createdAt: now,
        updatedAt: now,
        deletedAt: null,
        driverId: me.driverId,
        kind: ExpenseKind.maintenance,
        amountCents: amount,
        priceMilliCents: null,
        gallons: null,
        occurredOn: localDateIso(me?.org.timezone),
        note: note.trim() || null,
        loadId: null,
      },
    });
    setDollars("");
    setNote("");
  }

  return (
    <div className="stack">
      <h1 className="screen-title">Maintenance</h1>
      <div className="row">
        <Link to="/logs/fuel" className="chip">
          Fuel
        </Link>
        <Link to="/logs/detention" className="chip">
          Detention
        </Link>
      </div>
      <div className="card stack">
        <TextInput
          label="Cost $"
          placeholder="0.00"
          inputMode="decimal"
          value={dollars}
          onChange={(e) => setDollars(e.target.value)}
        />
        <TextInput
          label="Note"
          placeholder="What was fixed"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <Button variant="primary" onClick={() => void add()}>
          Add
        </Button>
      </div>
      <div className="card" style={{ padding: 0 }}>
        {(rows ?? []).map((r) => (
          <div key={r.id} className="list-item">
            <div>
              <div>{r.note ?? "Maintenance"}</div>
              <div className="muted">{r.occurredOn}</div>
            </div>
            <div>{formatUsd(r.amountCents)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
